import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/forgotPassword.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        },
      );

      const data = await res.json();

      setLoading(false);

      if (!data.success) {
        setError(data.message || "Napaka");
        return;
      }

      setMessage("Link za ponastavitev gesla je bil poslan na email.");
    } catch (err) {
      setLoading(false);
      setError("Server error");
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-white">
      <div className="w-full max-w-md p-6 border rounded-2xl shadow">
        <h2 className="text-xl font-bold mb-4 text-center">Pozabljeno geslo</h2>

        <form onSubmit={handleSubmit} className="flex flex-col">
          <input
            type="email"
            placeholder="Vnesi email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border p-3 rounded mb-3"
          />

          {error && <p className="text-red-500 text-sm">{error}</p>}
          {message && <p className="text-green-600 text-sm">{message}</p>}

          <button
            className="bg-midBlue text-white p-3 rounded mt-3"
            disabled={loading}
          >
            {loading ? "Pošiljam..." : "Pošlji link"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
